
import { Address, User } from "./userType";

export interface OrderState{
    orders: Order[];
    orderItem:OrderItemType|null;
    currentOrder: Order|null;
    paymentOrder:any|null;
    loading: boolean;
    error:string|undefined|null;
    orderCanceled:boolean;
    isSuccess:boolean|null
}

export interface Order{
    id: number;
    deliverDate: string;
    items:OrderItemType[];
    user:User;
    sellerId: number;
    orderStatus: OrderStatus;
    orderDate:string;
    paymentStatus:PaymentStatus
    shippingAddress:Address;
    // paymentDetails:any;
    totalMrpPrice: number;
    totalSellingPrice?: number; // Optional field
    discount?: number; // Optional field
    
    totalItem: number;
    
   
}

export enum OrderStatus{
    PENDING="PENDING",
    PLACED="PLACED",
    CONFIRMED="CONFIRMED",
    SHIPPED="SHIPPED",
    DELIVERED="DELIVERED",
    CANCELLED="CANCELLED"
}
export enum PaymentStatus{
    PENDING="PENDING",
     PROCESSING="PROCESSING",
    COMPLETED="COMPLETED",
    FAILED="FAILED"
}


export interface OrderItemType {
    id: number;
    productId: number;
    productDetailId:number;
    quantity: number;
    mrpPrice: number;
    sellingPrice: number;
 
  }

export interface PaymentLinkResponse{
    paymentId: string;
  
}